class Header {
  constructor(el) {
    this.dom = {};
    this.dom.el = el;
    this.setupDom()
    this.bindEvents()
  }

  setupDom = () => {
    this.dom.header = document.querySelector('.c-header')
  }

  bindEvents = () => {
    window.onscroll = this.onPageScroll
  }

  onPageScroll = () => {
    if (window.pageYOffset > 30) {
      this.dom.header.classList.add('sticky')
    } else {
      this.dom.header.classList.remove('sticky')
    }
  }

  static init = () => {
    const header = document.querySelector('.c-header')
    new Header(header)
  }
}

export default Header
